import { Component, OnInit } from '@angular/core';
import { res } from '../../../../common/language/text/res';
import { Subject } from 'rxjs';
import { Strings } from '../../../../common/language/strings';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SecurityFacade } from '../../../../common/facade/SecurityFacade';
import { UserCredential } from '../../../../common/model/UserCredential';
import { UserRole } from '../../../../common/model/UserRole';
import { DualListComponent } from 'angular-dual-listbox';
import { finalize } from 'rxjs/operators';
import { ConfirmationService } from '../../../../common/facade/confirmation.service';

@Component({
  selector: 'app-user-roles-modal',
  templateUrl: './user-roles-modal.component.html',
  styleUrls: ['./user-roles-modal.component.css']
})
export class UserRolesModalComponent implements OnInit {
  // Labels and text
  public modalTitle: res;
  public modalSave: res;
  public modaLoading: res;

  public errorGettingRoles: res;
  public errorSavingRoles: res;

  public user: UserCredential;
  public onClose$: Subject<number>;

  public roles: UserRole[];
  public userRoles: UserRole[];

  public alerts: { msg: string, type: string }[];

  public _loading: boolean;

  public dualListFormat;

  constructor(
    public strings: Strings,
    public bsModalRef: BsModalRef,
    private securityService: SecurityFacade,
    private confirmationService: ConfirmationService
  ) { 
    this.modalTitle = res.Roles;
    this.modalSave = res.Save;
    this.modaLoading = res.Loading;

    this.errorGettingRoles = res.ErrorGettingRoles;
    this.errorSavingRoles = res.ErrorSavingRoles;

    this.user = new UserCredential();
    this.onClose$ = new Subject();

    this.roles = [];
    this.userRoles = [];

    this.alerts = [];
    this._loading = false;

    this.dualListFormat = DualListComponent.DEFAULT_FORMAT;
    this.dualListFormat.add = this.strings.GetText(res.Add);
    this.dualListFormat.remove = this.strings.GetText(res.Delete);
    this.dualListFormat.all = this.strings.GetText(res.AllO);
    this.dualListFormat.none = this.strings.GetText(res.None);
  }

  ngOnInit(): void {
    this.getUserRoles();
  }

  public closeModal(): void {
    this.onClose$.next(0);
    this.bsModalRef.hide();
  }

  public getUserRoles(): void {
    this._loading = true;
    this.securityService.GetRoles(this.user.account)
    .pipe(finalize(() => this._loading = false))
    .subscribe(userRoles => {
      if (!userRoles.completed)
        return;

      this.userRoles = userRoles.data;

    }, error => {
      this.addAlert(`<strong> ${this.strings.GetText(this.errorGettingRoles)} </strong>`, 'danger');
    });
  }

  public async saveUserRoles(): Promise<void> {
    if (this.userRoles.length > 1) {
      this.addAlert('<strong>' + this.strings.GetText(res.UserMustHaveOnlyOneRole) + '</strong>', 'danger');
      return;
    }

    const result: boolean = await this.confirmationService.confirm();
    if (!result)
      return;

    this._loading = true;
    this.securityService.UpdateUserRoles(this.user.account, this.userRoles)
    .pipe(finalize(() => this._loading = false))
    .subscribe(result => {
      if (!result.completed)
        return;

      this.onClose$.next(1);
      this.bsModalRef.hide();

    }, error => {
      this.addAlert(`<strong> ${this.strings.GetText(this.errorSavingRoles)} </strong>`, 'danger');
    });
  }

  public addAlert(message: string, type: string): void {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  public onAlertClose(dismissedAlert: { msg: string, type: string }): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

}
